import React from 'react';
import { Link } from 'react-router-dom';
import { FaClipboardList, FaRegLightbulb, FaFileAlt, FaUsers, FaCalendarCheck } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';

function RessourcesGuides() {
  return (
    <div className="container my-5">
      <h1 className="display-4 text-center mb-5">Ressources et Guides pour les Clubs</h1>
      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <FaClipboardList className="icon text-primary mb-3" />
              <h4 className="card-title">Règlements des Clubs</h4>
              <p className="card-text no-dark-mode">
                Découvrez les règles à suivre pour la bonne gestion des clubs, les normes de sécurité, et le respect des locaux.
              </p>
              <Link to="/Reglement" className="btn btn-primary">
                En savoir plus
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <FaUsers className="icon text-success mb-3" />
              <h4 className="card-title">Protocoles Internes</h4>
              <p className="card-text no-dark-mode">
                Consultez les protocoles pour organiser vos activités, gérer les financements et le matériel.
              </p>
              <Link to="/protocoles" className="btn btn-success">
                En savoir plus
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <FaRegLightbulb className="icon text-warning mb-3" />
              <h4 className="card-title">Astuces pour la Gestion de Club</h4>
              <p className="card-text no-dark-mode">
                Trouvez des astuces pour recruter des membres, organiser des réunions efficaces, et promouvoir vos activités.
              </p>
              <Link to="/EnConstruction" className="btn btn-warning">
                Découvrir les astuces
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <FaFileAlt className="icon text-danger mb-3" />
              <h4 className="card-title">Modèles et Templates</h4>
              <p className="card-text no-dark-mode">
                Accédez à des modèles de documents tels que des formulaires d'inscription et des comptes rendus de réunions.
              </p>
              <Link to="/FicheProjet" className="btn btn-danger">
                Voir les modèles
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <FaCalendarCheck className="icon text-info mb-3" />
              <h4 className="card-title">Guide des Événements</h4>
              <p className="card-text no-dark-mode">
                Apprenez à organiser un événement, de la planification à la promotion.
              </p>
              <Link to="/Projets" className="btn btn-info">
                En savoir plus
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="card shadow-sm h-100">
            <div className="card-body">
              <FaClipboardList className="icon text-secondary mb-3" />
              <h4 className="card-title">FAQ</h4>
              <p className="card-text no-dark-mode">
                Consultez les questions fréquemment posées par les membres des clubs.
              </p>
              <Link to="/faq" className="btn btn-secondary">
                Voir la FAQ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RessourcesGuides;